// extracted by mini-css-extract-plugin
export default {"img":"appModal_img__tZKOZ","title":"appModal_title__OIhse","desc":"appModal_desc__sa7xl"};